import { NextSeo } from 'next-seo';
import React from 'react';
import { toast } from 'react-toastify';

import LandingPageContent from '@rebound/design-system/modules/landing/components/LandingPageContent';

import PageLayout from '@components/PageLayout';

import LandingPagePlaceholder from './LandingPagePlaceholder';

type LandingPageCommonProps = {
  retailerData: any;
  form: React.ReactNode;
  decryptionLoading?: boolean;
  title: string;
  description: string;
  searchOrderJourney: boolean;
};

export const LandingPage = ({
  retailerData,
  decryptionLoading = false,
  form,
  title,
  description,
  searchOrderJourney,
}: LandingPageCommonProps) => {
  const retailer = retailerData.retailer;

  if (retailerData.loading || decryptionLoading) {
    return <LandingPagePlaceholder />;
  }

  if (!retailer) {
    toast.error('Invalid retailer');
    return null;
  }

  return (
    <>
      <NextSeo title={`${retailer.name ?? 'Retailer'} - Returns Center`} />
      <PageLayout
        logoSrc={retailer.theme.logo}
        faviconSrc={retailer.theme.favicon}
        advertisingBanner={retailer.advertisingBanner}
      >
        <LandingPageContent
          retailer={retailerData.retailer}
          title={title}
          description={description}
          form={form}
          searchOrderJourney={searchOrderJourney}
        />
      </PageLayout>
    </>
  );
};
